




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ProConfig from '@/config/config'
import LabelValueUtils from '@/utils/LabelValueUtils'
import JavaHttp from '@/common/network/JavaHttp'
import FuncUtils from '@/common/utils/FuncUtils'
import ValidateUtils from '@/common/utils/ValidateUtils'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'FormChangePassword',
  components: {}
})
export default class FormChangePassword extends Vue {
  @Prop({ required: true }) public srcData!: any
  @Prop({ default: false }) public uiStatus!: number
  public formRules = {
    oldPassword: [{ required: true, message: '当前密码必填' }],
    newPassword: [
      { required: true, message: '新密码必填' },
      {
        validator: (rule: any, value: any, callback: Function) => {
          if (!value) {
            callback(new Error('请输入新密码'))
            return
          }
          if (value.length < 8) {
            callback(new Error('密码必须为8到20位,且包含字母和数字'))
            return
          }
          const reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/)
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('密码必须为8到20位,且包含字母和数字'))
            return
          }
        }
      }
    ],
    onceMore: [
      { required: true, message: '确认密码必填' },
      {
        validator: (rule: any, value: any, callback: Function) => {
          if (!this.formData.newPassword) {
            callback(new Error('请填写新密码'))
            return
          }
          if (this.formData.newPassword == this.formData.onceMore) {
            callback()
          } else {
            callback(new Error('密码不一致'))
          }
        }
      }
    ]
  }

  public formData = {
    oldPassword: '',
    newPassword: '',
    onceMore: ''
  }
  public btnLoading = false
  public uiLock = false

  submitForm() {
    const form: any = this.$refs.formData
    form.validate((valid: any) => {
      if (valid) {
        this.submitData()
      } else {
        return false
      }
    })
  }

  resetForm() {
    const form: any = this.$refs.formData
    form.resetFields()
  }

  closeForm() {
    this.resetForm()
    this.$emit('cancelDlg')
  }
  submitData() {
    this.btnLoading = true
    const params = {
      oldPassword: FuncUtils.rsaEncode(this.formData.oldPassword),
      password: FuncUtils.rsaEncode(this.formData.newPassword)
    }
    UserModule.saveUserInfo(this.srcData)
    JavaHttp.postData('/user/pwdEdit', params)
      .then((res: any) => {
        this.btnLoading = false
        if (res.code === 0) {
          this.$emit('submitDlg', true)
          FuncUtils.hitMessageSuccess(res.msg || '操作成功')
          UserModule.clearUserInfo()
          this.$alert('密码修改成功，请重新登录', '提示', {
            confirmButtonText: '重新登录',
            callback: (action) => {
              location.reload()
            }
          })
        } else {
          FuncUtils.hitMessageError(res.msg)
          UserModule.clearUserInfo()
        }
      })
      .catch(() => {
        this.btnLoading = false
        UserModule.clearUserInfo()
      })
  }
}
